import React from 'react';

interface ComponentProps {
  palette: React.ReactNode;
  canvas: React.ReactNode;
  properties: React.ReactNode;
}

/**
 * CSS-grid 3-column layout for the form builder.
 * Columns: left (palette) | centre (canvas) | right (properties)
 */
const FormBuilderLayout: React.FC<ComponentProps> = ({ palette, canvas, properties }) => (
  <div className="form-builder-layout">
    <div className="form-builder-panel" aria-label="Field palette">
      {palette}
    </div>
    <div aria-label="Form canvas">
      {canvas}
    </div>
    <div className="form-builder-panel form-builder-panel--right" aria-label="Field properties">
      {properties}
    </div>
  </div>
);

export default FormBuilderLayout;
